import { withTranslation, Trans } from "next-i18next";
import Link from "../../core/Link";

const AutonomousLinks = ({ t }) => (
  <div className="d-flex flex-column">
    <Link
      href="/about"
      className="font-size-sm text-dark font-weight-light"
    >
      {t("common:footer.about")}
    </Link>
    <Link
      href="/contact-us"
      className="font-size-sm text-dark font-weight-light"
    >
      {t("common:footer.contact")}
    </Link>

    <Trans
      i18nKey="common:footer.help_center.text"
      // eslint-disable-next-line
      components={[<a href={t("common:footer.help_center.href")} target='_blank' className="font-size-sm text-dark font-weight-light" />]}
    />
  </div>
);

export default withTranslation("common")(AutonomousLinks);
